exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".current_buySell .badge {\n  padding: 5px 16px;\n  width: 80px;\n  height: 20px;\n  text-align: center;\n  padding: 5px 10px;\n  color: #ffffff; }\n\n.current_buySell .bdg_blue {\n  background-color: #7cb5ec; }\n\n.current_buySell .bdg_orange {\n  background-color: #fa871b; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Current_buy_sell.style.scss
// module id = 613
// module chunks = 0